/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FormResponseStatus {
    NOT_SENT = 'NotSent',
    NEW = 'New',
    DRAFT = 'Draft',
    READY_FOR_SUBMISSION = 'ReadyForSubmission',
    SUBMITTED = 'Submitted',
}
